/* src/app/main/declaration-reports/declaration-report-selection.component.scss */
/*# sourceMappingURL=declaration-report-selection.component-NOHZFC3A.css.map */
